import React from "react";
import {v4 as uuidv4} from "uuid";
import { IWhitespaceMenuEntry } from "../../interfaces/Components/WhitespaceMenu/IWhitespaceMenuEntry";
import { NavDropdown } from "react-bootstrap";
import "./WhitespaceMenu.scss";

export const WhitespaceMenuEntry: React.FC<IWhitespaceMenuEntry> = ({whitespaceMenuItem, rootReturnUrl, isRootMenu}) => {
   
    return (
    <>
            { whitespaceMenuItem.children.length > 0 ?

                    <NavDropdown id={`${whitespaceMenuItem.name}`} key={whitespaceMenuItem.name} title={whitespaceMenuItem.name} className={`me-auto ${!isRootMenu ? 'dropend':''}`} data-testid={`menu_${whitespaceMenuItem.name}`}>
                    {whitespaceMenuItem.children && whitespaceMenuItem.children.map((menuItem, idx)=> {
                        return (<WhitespaceMenuEntry key={idx} whitespaceMenuItem={menuItem} rootReturnUrl={rootReturnUrl} isRootMenu={false}/>
                        )
                    })
                    }
                    </NavDropdown>:
                    !whitespaceMenuItem.url?.toLowerCase().startsWith("javascript") ?
                    <NavDropdown.Item href={`${rootReturnUrl}${whitespaceMenuItem.url}`} key={uuidv4()} data-testid={`submenu_${whitespaceMenuItem.name}`}>{whitespaceMenuItem.name} </NavDropdown.Item>
                    // eslint-disable-next-line
                    :<NavDropdown.Item href="#" onClick={()=>{eval(whitespaceMenuItem.url!)}} key={uuidv4()} data-testid={`submenu_${whitespaceMenuItem.name}`}>{whitespaceMenuItem.name} </NavDropdown.Item>
            }
    </>
)}


